module.exports = __webpack_public_path__ + "media/sound.7fd5671a.mp3";